import React from "react";
import {
  Datagrid,
  Filter,
  SearchInput,
  ReferenceField,
  ListProps,
  FunctionField,
  TextField,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridinRow, GridLabel } from "utils/style";
import CustomDateField from "components/CustomDateField";
import StatusField from "components/StatusField";
import moment from "moment";
import TypeField from "components/TypeField";
import { SchoolIdSelected } from "utils/tools";
import ListWrapper from "../../components/ListWrapper";
import ActionsMenu from "../../components/ActionsMenu";
import ListShowButton from "../../components/ListShowButton";
import EnhancedRoutePlanEditButton from "./components/EnhancedRoutePlanEditButton";
import WaveNameListField from "./components/WaveNameListField";

const EnhancedRoutePlanFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const EnhancedRoutePlanList = (props: ListProps) => {
  const breadcrumb = [
    { link: "/enhancedBusSchedulePlans", title: "AI Route Plans" },
  ];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="AI Route Plans"
        exporter={false}
        bulkActionButtons={false}
        filters={<EnhancedRoutePlanFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        {...props}
      >
        <Datagrid>
          <ReferenceField
            label="School"
            source="busScheduleId"
            reference="busSchedules"
            emptyText="-"
            link={false}
          >
            <ReferenceField source="schoolId" reference="schools" link={false}>
              <TextField source="name" />
            </ReferenceField>
          </ReferenceField>

          <WaveNameListField label="Wave" />

          <FunctionField
            label="Route Plan Created"
            render={() => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Date :
                  </Typography>
                  <CustomDateField source="createdAt" isDateTime />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Days :
                  </Typography>
                  <ReferenceField
                    source="busScheduleId"
                    reference="busSchedules"
                    emptyText="-"
                    link={false}
                  >
                    <FunctionField
                      render={(record: any) => {
                        let days: string = "";

                        if (record.isMonday) {
                          days = days + " Monday,";
                        }
                        if (record.isTuesday) {
                          days = days + " Tuesday,";
                        }
                        if (record.isWednesday) {
                          days = days + " Wednesday,";
                        }
                        if (record.isThursday) {
                          days = days + " Thursday,";
                        }
                        if (record.isFriday) {
                          days = days + " Friday,";
                        }

                        return days.replace(/,(?=[^,]*$)/, "");
                      }}
                    />
                  </ReferenceField>
                </Grid>
              </SanitizedGrid>
            )}
          />
          <CustomDateField
            label="Last Improvement By AI"
            source="lastImprovedByRouteOptimization"
          />
          <FunctionField
            label="Route Plan Revised"
            render={(record: any) => {
              const createdAt = moment.utc(record.createdAt);
              const updateAt = moment.utc(record.updatedAt);
              const diffDate = updateAt.diff(createdAt, "seconds");

              if (diffDate < 1) {
                return "-";
              } else {
                return updateAt.format("DD / MM / YYYY, hh:mm A");
              }
            }}
          />
          <CustomDateField
            label="Next Effective Date"
            source="nextEffectiveDate"
          />
          <ReferenceField
            label="Type"
            source="busScheduleId"
            reference="busSchedules"
            emptyText="-"
            link={false}
          >
            <TypeField source="type" type="busSchedule" />
          </ReferenceField>
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <ActionsMenu
                render={[
                  record.routePlan !== null && (
                    <ListShowButton record={record} />
                  ),
                  <EnhancedRoutePlanEditButton {...record} />,
                ]}
              />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default EnhancedRoutePlanList;
